import React, { useEffect, useState } from 'react';

type BitTabsProps = {
	allTabs: {
		tabHeader: string;
		tabActive: boolean;
		tabContent: JSX.Element;
	}[];
};

const BitTabs: React.FC<BitTabsProps> = ({ allTabs }) => {
	const [stateAllTabs, setStateAllTabs] = useState(allTabs);

	function onlyOneTabActive(currentTab: any = null) {
		let controlaUnicaTabAtiva = false;
		const newStateAllTabs: BitTabsProps['allTabs'] = [];

		stateAllTabs.map(tab => {
			const newTab = tab;

			if (currentTab === null) {
				if (controlaUnicaTabAtiva && tab.tabActive) {
					newTab.tabActive = false;
				}

				if (newTab.tabActive) {
					controlaUnicaTabAtiva = true;
				}
			} else {
				newTab.tabActive = tab === currentTab;
			}

			newStateAllTabs.push(newTab);

			return null;
		});

		setStateAllTabs(newStateAllTabs);
	}

	useEffect(() => {
		onlyOneTabActive();
		setStateAllTabs(allTabs);
	}, [allTabs]);

	return (
		<div className={`tabs-custom`}>
			<div className="navigation-tabs-custom">
				{stateAllTabs.map(tab => {
					const activeTab = tab.tabActive ? 'tab-active' : null;
					return (
						<button
							type="button"
							className={`tab-custom ${activeTab}`}
							onClick={() => {
								onlyOneTabActive(tab);
							}}
						>
							{tab.tabHeader}
						</button>
					);
				})}
			</div>
			<div className="content-tabs-custom">
				{stateAllTabs.map(tab => {
					const returnContent = tab.tabActive ? tab.tabContent : null;
					return returnContent;
				})}
			</div>
		</div>
	);
};

export default BitTabs;
